module.exports = __webpack_public_path__ + "static/accm-f5b6ed586580d2cf3f3ac3c7997f0e15.jpg";